var separator = 'fx_2d2fb1e5_l4z92i0';

export { separator };
//# sourceMappingURL=separator.vanilla.mjs.map
